var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIaIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 27,
    viewBox: "0 0 21 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.59375 26.5C3.30312 26.5 2.21484 26.0612 1.32891 25.1837C0.442969 24.3062 0 23.2283 0 21.95V5.05C0 3.79333 0.442969 2.72083 1.32891 1.8325C2.21484 0.944167 3.30312 0.5 4.59375 0.5H21V20C20.4312 20 19.9609 20.1896 19.5891 20.5687C19.2172 20.9479 19.0312 21.4083 19.0312 21.95C19.0312 22.5133 19.2172 22.9792 19.5891 23.3475C19.9609 23.7158 20.4312 23.9 21 23.9V26.5H4.59375ZM4.59375 23.9H16.8328C16.7016 23.5967 16.5977 23.2879 16.5211 22.9737C16.4445 22.6596 16.4062 22.3183 16.4062 21.95C16.4062 21.6033 16.4391 21.2675 16.5047 20.9425C16.5703 20.6175 16.6797 20.3033 16.8328 20H4.59375C4.025 20 3.55469 20.1896 3.18281 20.5687C2.81094 20.9479 2.625 21.4083 2.625 21.95C2.625 22.5133 2.81094 22.9792 3.18281 23.3475C3.55469 23.7158 4.025 23.9 4.59375 23.9ZM2.625 17.8225C2.93125 17.6708 3.24297 17.5625 3.56016 17.4975C3.87734 17.4325 4.22187 17.4 4.59375 17.4H18.375V3.1H4.59375C4.025 3.1 3.55469 3.28958 3.18281 3.66875C2.81094 4.04792 2.625 4.50833 2.625 5.05V17.8225ZM6.20156 14.8H7.80937L8.62969 12.4925H12.3375L13.1578 14.8H14.7656L11.2875 5.7H9.64687L6.20156 14.8ZM9.08906 11.16L10.4344 7.39H10.5328L11.8781 11.16H9.08906Z",
    fill: "#00BC92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIaIcon1);
export default __webpack_public_path__ + "static/media/iaIcon_1.c02f0f4e5536b1e5b79aa3a66f1c656a.svg";
export { ForwardRef as ReactComponent };